import NumIndicator from './NumIndicator';

export default NumIndicator;
